import logoAreaWelcome from './logo-area-welcome.png';
import orangeRectangle from './orange-rectangle.png';
export default {
	logoAreaWelcome,
	orangeRectangle
};
